import React, { useEffect } from 'react';
import successgif from '../../../assets/gif/successfullgif.gif';
import close from '../../../assets/icons/close.svg';

const PermissionSuccessModal = ({ message, onClose, autoClose = true, autoCloseDelay = 3000 }) => {
  useEffect(() => {
    if (autoClose && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [autoClose, autoCloseDelay, onClose]);

  if (!message) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-success" style={{ position: 'relative' }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginBottom: '10px' }}>
          <button className="close-btn" onClick={onClose}>
            <img src={close} alt="Close" />
          </button>
        </div>

        <div className="row justify-content-center mb-2">
          <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <img src={successgif} style={{ width: '100px', height: '100px' }} alt="Success" />
            <p style={{ textAlign: 'center', marginTop: '15px', fontSize: '16px', fontWeight: '500' }}>
              {message}
            </p>
          </div>
        </div>

        {autoClose && (
          <div className="row justify-content-center">
            <div className="col-md-12" style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '12px', color: '#666', margin: '10px 0' }}>
                This modal will close automatically in {autoCloseDelay / 1000} seconds
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PermissionSuccessModal;
